import { contractDate } from "./planningDates";
const normalizedName = value => String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().split(/\s+/).sort().join(" ");

export function recentWorkers(candidates, contracts, now = new Date()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat("en", { timeZone: "Europe/Paris", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(now).map(part => [part.type, part.value]));
  const today = new Date(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
  const cutoff = new Date(today); cutoff.setDate(cutoff.getDate() - 60);
  const eligible = new Set();
  contracts.forEach(contract => {
    const start = contractDate(contract.DateDebut);
    const end = contractDate(contract.DateFinMission || contract.DateFin);
    if (!start || start > today || (end && (end < cutoff || end < start))) return;
    const id = contract.candidateId || contract.candidate?._id;
    const matches = candidates.filter(candidate => id ? String(candidate._id) === String(id) : contract.IdInterimaire != null && candidate.pld != null ? String(candidate.pld) === String(contract.IdInterimaire) : normalizedName(`${candidate.firstname || ""} ${candidate.lastname || ""}`) === normalizedName(contract.NomPrenom));
    // Homonymes : ne pas attribuer un contrat sans identifiant fiable.
    if (matches.length === 1) eligible.add(matches[0]._id);
  });
  return candidates.filter(candidate => eligible.has(candidate._id));
}
